<template>
<div>
    <div class="qst-question">{{ data.title }}</div>
    <div v-if="data.type === 'text' || data.type === 'email'">
      <input
        type="text"
        :placeholder="data.placeholder"
        class="qst-control"
        v-model="controlValue"
        @change="onChangeValue"
        @blur="onBlurControl"
      >
    </div>
    <div v-if="data.type === 'textarea'">
      <textarea
        v-model="controlValue"
        :placeholder="data.placeholder"
        rows="4"
        class="qst-control"
        @change="onChangeValue"
      ></textarea>
    </div>
    <div v-if="data.type === 'select'">
      <select v-model="controlValue" class="qst-control" @change="onChangeValue">
        <option value="">Selecciona una opción</option>
        <option v-for="opt in data.options" :key="opt.value" :value="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>
    <div v-if="data.type === 'scale'">
      <f7-row>
        <f7-col>

        </f7-col>
      </f7-row>
      <f7-list simple-list outline-ios strong-ios>
        <f7-list-item>
          <div style="width: 100%; margin: 0 16px">
            <f7-range :min="minPrice" :max="maxPrice" :step="2500" :value="[priceMin, priceMax]" :label="true"
              :dual="true" color="#0A243F" @range:change="onPriceChange" />
          </div>
        </f7-list-item>
      </f7-list>
      <f7-row>
        <f7-col></f7-col>
        <f7-col>
          <f7-list class="m-t-0" no-hairlines>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Mínimo</div>
                  <div class="item-input-wrap">
                    <input type="text" placeholder="" :value="priceMin" />
                  </div>
                </div>
              </div>
            </li>
          </f7-list>

        </f7-col>
        <f7-col>
          <f7-list class="m-t-0" no-hairlines>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Máximo</div>
                  <div class="item-input-wrap">
                    <input type="text" placeholder="" :value="`${priceMax} ${priceMax == maxPrice ? ' o Más' : ''}`" />
                  </div>
                </div>
              </div>
            </li>
          </f7-list>
        </f7-col>
        <f7-col></f7-col>
      </f7-row>
    </div>
    <div v-if="data.type === 'images'">
      <image-uploader @change="onChangeValue"></image-uploader>
    </div>
    <div v-if="data.type === 'date'">
      <input type="date" class="qst-control" style="width: fit-content !important;" @change="onChangeValue" v-model="controlValue" >
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { EventBus } from '../../../utils/eventBus'

export default {
  name:"OptionalQuestion",
  props:{
    data:Object
  },
  data(){
    return{
      controlValue: '',
      minPrice: 25000,
      maxPrice: 200000,
      priceMin: 25000,
      priceMax: 200000
    }
  },
  mounted(){
    this.minPrice = this.data.min
    this.maxPrice = this.data.max
    this.priceMin = this.data.min
    this.priceMax = this.data.max
  },
  methods:{
    onPriceChange(values) {
      this.priceMin = values[0]
      this.priceMax = values[1]
      EventBus.$emit('update-answer', { id:this.data.id, value:`${this.priceMin},${this.priceMax}` })
    },
    onChangeValue(event){
      EventBus.$emit('update-answer', { id:this.data.id, value: this.controlValue })
    },
    onBlurControl(event){
      if(!this.data.pattern)
      return

      let pattern = new RegExp(this.data.pattern)
      let result = pattern.test(this.controlValue)
      if(!result){
        event.target.setCustomValidity( this.data.notValidMessage)
        event.target.reportValidity()
      }
    },
  }

}
</script>

<style>
.qst-question {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
}

.qst-control {
  box-sizing: border-box !important;
  width: 100% !important;
  background-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #c4c4c4 !important;
  border-radius: 5px !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
  font-size: 14px !important;
  color: #0A243F !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-duration: 150ms !important;
}

.qst-control::placeholder {
  color: #A8A8A8 !important;
}

.qst-control:focus {
  outline: none;
  border-color: #1d2244 !important;
}
</style>